import { gql } from '@apollo/client';

const CHECK_PASSWORD = gql`
  mutation CheckPasswordMutation($checkPasswordInput2: CheckPasswordInput!) {
    checkPassword(input: $checkPasswordInput2)
  }
`;

export default CHECK_PASSWORD;
